/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarkDraftListDto } from '../../models/survey-mark-draft-list-dto';

export interface ListSurveyMarkDrafts$Params {}

export function listSurveyMarkDrafts(
  http: HttpClient,
  rootUrl: string,
  params?: ListSurveyMarkDrafts$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarkDraftListDto>> {
  const rb = new RequestBuilder(rootUrl, listSurveyMarkDrafts.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarkDraftListDto>;
      }),
    );
}

listSurveyMarkDrafts.PATH = '/me/surveyMarks/drafts';
